import React, { useRef, useEffect, useState } from 'react'
import bootstrapScopedStyles from '../../styles/bootstrapScoped.min.module.css'
import formStyles from './../../branding/formStyles'
import customFormStyles from '../../styles/formStyles.module.css'

export default function OnfsRadioGroup({
  name,
  label,
  children,
  handleChange,
  error,
  inline = false,
  style = {},
  indent = '10px',
  required
}) {
  const childrenContainerRef = useRef()
  const parentRef = useRef()
  const [radioValue, setRadioValue] = useState('')

  const childrenStyle = inline
    ? { ...formStyles.inlineContainer, ...style }
    : style

  useEffect(() => {
    //  add name to child radios...
    const childrenRadios =
      childrenContainerRef.current.getElementsByTagName('input')
    for (let i = 0; i < childrenRadios.length; i++) {
      childrenRadios[i].setAttribute('name', `${name}_group`)
    }
  }, [])

  useEffect(() => {
    const childrenRadios =
      childrenContainerRef.current.getElementsByTagName('input')
    for (let i = 0; i < childrenRadios.length; i++) {
      if (childrenRadios[i].checked) {
        setRadioValue(childrenRadios[i].id)
      }
    }
  })

  return (
    <fieldset
      className={bootstrapScopedStyles['form-group']}
      id={name}
      aria-describedby={error ? name + `-error` : null}
      aria-invalid={error ? 'true' : 'false'}
      onClick={(e) => {
        e.persist()

        if (e.target.checked) {
          setRadioValue(e.target.id)
        }
        setTimeout(() => handleChange(parentRef.current), 1)
      }}
    >
      {/* Hidden input field to hold value of radio group */}
      <label hidden htmlFor={'hiddenRadio' + name}>
        Radio Control
      </label>
      <input
        id={'hiddenRadio' + name}
        style={{ display: 'none' }}
        ref={parentRef}
        name={name}
        hidden
        readOnly
        value={radioValue}
      />

      <div className={bootstrapScopedStyles.row}>
        <legend
          style={formStyles.legend}
          className={`${bootstrapScopedStyles['col-form-label']} ${
            bootstrapScopedStyles.col
          } ${bootstrapScopedStyles['pt-0']} ${
            required ? customFormStyles.required : ''
          }`}
        >
          {label}
        </legend>
      </div>
      <div className={bootstrapScopedStyles.row} style={{ marginLeft: indent }}>
        <div ref={childrenContainerRef} style={childrenStyle}>
          {React.Children.map(children, (child) => (
            <div key={`${name}_${child.props.name}`}>{child}</div>
          ))}
        </div>
      </div>
      {error && (
        <div
          role='alert'
          id={name + '-error'}
          className={`${bootstrapScopedStyles.alert} ${bootstrapScopedStyles['alert-danger']}`}
        >
          {error}
        </div>
      )}
    </fieldset>
  )
}
